import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, HostListener, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { RegExpHelper } from '@atlas-workspace/shared/models';
import { ToasterService } from '@atlas-workspace/shared/service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'atl-download-modal',
    templateUrl: './download-modal.component.html',
    styleUrls: ['./download-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})

export class DownloadModalComponent implements OnInit {
    @HostListener('window:keydown.enter', ['$event'])
    handleEnter(event: KeyboardEvent): void {
      event.preventDefault();
      this.confirm();
    }
    @Output() private readonly saveChanges = new EventEmitter<string>();

    public disableSaveButton = true;
    public form!: FormGroup;

    constructor(
        private readonly activeModal: NgbActiveModal,
        private readonly cdr: ChangeDetectorRef,
        private readonly fb: FormBuilder,
        private readonly toasterService: ToasterService,
        private readonly translateService: TranslateService
    ) { }

    ngOnInit(): void {
        this.initForm();
        this.cdr.markForCheck();
    }

    closeModal(): void {
        this.activeModal.close();
    }

    confirm(): void {
        if (this.form?.invalid) {
            return;
        }
        this.saveChanges.emit(this.form?.get('email')?.value);
        this.closeModal();
        const message = this.translateService.instant('Title.Email_sent');
        this.toasterService.openSuccessToast(message);
    }

    private initForm(): void {
        this.form = this.fb.group({
            email: new FormControl(null, [Validators.required, Validators.pattern(RegExpHelper.email)]),
        });
    }

}